/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CountryLiveData interface.
 */
export function instanceOfCountryLiveData(value) {
    if (!('country' in value) || value['country'] === undefined)
        return false;
    if (!('generations' in value) || value['generations'] === undefined)
        return false;
    if (!('sessionInits' in value) || value['sessionInits'] === undefined)
        return false;
    return true;
}
export function CountryLiveDataFromJSON(json) {
    return CountryLiveDataFromJSONTyped(json, false);
}
export function CountryLiveDataFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'country': json['country'],
        'generations': json['generations'],
        'sessionInits': json['session_inits'],
    };
}
export function CountryLiveDataToJSON(json) {
    return CountryLiveDataToJSONTyped(json, false);
}
export function CountryLiveDataToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'country': value['country'],
        'generations': value['generations'],
        'session_inits': value['sessionInits'],
    };
}
